// extracted by mini-css-extract-plugin
export default {"wrapper":"Programme_wrapper__OYIwU","header":"Programme_header__WuCRc","downloadLink":"Programme_downloadLink__eFMSx"};